
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import LanguageSelectCard from "../Base/LanguageSelectCard.vue";
import AlertBoxEditable from "../Base/AlertBoxEditable.vue";
import GameTypeGeneral from "./GameTypesTabs/GameTypeGeneral.vue";
import GameTypeIntro from "./GameTypesTabs/GameTypeIntro.vue";
import GameTypeWeapons from "./GameTypesTabs/GameTypeWeapons.vue";
import GameTypeInventory from "./GameTypesTabs/GameTypeInventory.vue";
import GameTypeFX from "./GameTypesTabs/GameTypeFX.vue";

import AddWeapon from "./GameTypesTabs/GameTypesAdd.vue/GameTypeWeaponsAdd.vue";
import AddInventory from "./GameTypesTabs/GameTypesAdd.vue/GameTypeInventoryAdd.vue";
import AddFX from "./GameTypesTabs/GameTypesAdd.vue/GameTypeFXAdd.vue";

import SavePanel from "../Base/SavePanel.vue";
import { GAMETYPE_ID, Season } from "@/models/GameType";
import { cloneDeep, isEqual, toArray } from "lodash";

@Component({
  components: {
    LanguageSelectCard,
    GameTypeGeneral,
    GameTypeIntro,
    GameTypeWeapons,
    GameTypeInventory,
    AlertBoxEditable,
    GameTypeFX,
    AddWeapon,
    AddInventory,
    AddFX,
    SavePanel,
  },
})
class ViewGameTypes extends Vue {
  @Prop({ default: null }) readonly seasonData!: Season;
  seasonDataObject = {} as Season;
  tabPicked = 0;
  showLanguageButton = false;
  showSavePanel = false;
  isEditingLocked = true;
  isSavedOrDiscard = false;
  showAlertBox = false;

  get getGameTypeID(): GAMETYPE_ID {
    if (this.$store.state.gameStore.gameType.length > 0)
      return this.$store.state.gameStore.gameTypeSelected;
    return GAMETYPE_ID.MANHUNT;
  }

  get showIfManHunt(): boolean {
    if (this.getGameTypeID === GAMETYPE_ID.MANHUNT) return true;
    return false;
  }

  get getGameType(): string {
    if (this.getGameTypeID === GAMETYPE_ID.MANHUNT) return "manhunt";
    return "quest";
  }

  discardChanges(value: boolean): void {
    this.seasonDataObject = cloneDeep(this.getSeasonData);

    this.showSavePanel = false;
    if (value) {
      this.$store.dispatch("gameStore/addEditLock", {
        slug: this.getSeasonData.slug,
        value: false,
      });
      this.isEditingLocked = true;
      this.$emit("selectableTable", true);
    } else {
      this.isSavedOrDiscard = true;
      this.$store.dispatch("gameStore/addEditLock", {
        slug: this.getSeasonData.slug,
        value: true,
      });
    }
  }

  created(): void {
    this.seasonDataObject = cloneDeep(this.getSeasonData);
    this.isEditingLocked = true;
    this.$store.commit("gameStore/currentlyEditing", false);
    this.$emit("selectableTable", true);
    window.addEventListener("beforeunload", this.confirm_leaving);
  }

  get getLanguageButton(): boolean {
    return this.showLanguageButton;
  }

  get getSeasonDataObject(): Season {
    return this.seasonDataObject;
  }

  get getWeaponGuiltData(): boolean {
    var results = toArray(this.seasonDataObject.weapons);
    if (results.filter((x) => x.guilt).length > 1) {
      return false;
    }
    return true;
  }

  get getSeasonData(): Season {
    return this.$store.state.gameStore.gameType.filter(
      (x: Season) => x.slug === this.seasonData.slug
    )[0];
  }

  @Watch("getSeasonData", { deep: true })
  async onPropertyChanged(): Promise<void> {
    this.seasonDataObject = cloneDeep(this.getSeasonData);
  }
  /*
  There is definitely a better way to do this, you could recusively loop both objects and find difference.
  For speed of use I am doing the below. Need to return as this is not optimal at all.
  TODO: NEEDS REFACTORING
   */
  updateTempObject(data: any): void {
    this.isSavedOrDiscard = false;
    if (data.type == "General") {
      this.seasonDataObject.name.en = data.seasonData.name.en;
      this.seasonDataObject.teamSizeOverride = data.seasonData.teamSizeOverride;
      this.seasonDataObject.imgs[0] = data.seasonData.imgs[0];
    }
    if (data.type == "Intro") {
      this.seasonDataObject.intro = data.seasonData.intro;
      this.seasonDataObject.outro = data.seasonData.outro;
    }
    if (data.type == "FX") {
      this.seasonDataObject.fx[data.fx.slug].desc = data.fx.desc;
    }
    if (data.type == "inv") {
      this.seasonDataObject.inv_items[data.inv.slug] = data.inv;
    }
    if (data.type == "weapon") {
      this.seasonDataObject.weapons[data.weapon.uid] = data.weapon;
    }
    if (!this.getWeaponGuiltData) {
      this.$bvModal.show("team-modal-alert-edit");
    }
    if (!isEqual(this.getSeasonData, this.seasonDataObject)) {
      this.showSavePanel = true;
    } else {
      this.showSavePanel = false;
    }
    this.$emit("selectableTable", data.selectable);
  }
  saveChanges(value: boolean): void {
    this.seasonDataObject.is_edit = !value;

    this.$store.dispatch("gameStore/updateSeasonType", this.seasonDataObject);
    this.showSavePanel = false;
    if (value) {
      this.isEditingLocked = true;
      this.$store.commit("gameStore/currentlyEditing", false);
      this.$emit("selectableTable", true);
    } else {
      this.isSavedOrDiscard = true;
    }
  }
  getTabs(event: any): void {
    this.tabPicked = event;
    if (this.tabPicked < 2) {
      this.showLanguageButton = false;
    } else {
      this.showLanguageButton = true;
    }
  }
  handleSubmitPressed(): void {
    if (this.showIfManHunt) {
      if (this.tabPicked == 4) {
        this.$bvModal.show("team-modal-add-fx");
      }
      if (this.tabPicked == 3) {
        this.$bvModal.show("team-modal-add-inventory");
      }
      if (this.tabPicked == 2) {
        this.$bvModal.show("team-modal-add-weapon");
      }
    } else {
      if (this.tabPicked == 3) {
        this.$bvModal.show("team-modal-add-fx");
      }
      if (this.tabPicked == 2) {
        this.$bvModal.show("team-modal-add-inventory");
      }
    }
  }
  handleUnlock(): void {
    this.$store.dispatch("gameStore/addEditLock", {
      slug: this.getSeasonData.slug,
      value: true,
    });
    this.isEditingLocked = false;
    this.$emit("selectableTable", false);
  }
  handlelock(): void {
    this.discardChanges(true);
  }
  confirm_leaving(evt: any) {
    if (!this.isEditingLocked) {
      const unsaved_changes_warning =
        "You are currently in edit mode and potentially have unsaved changes. Proceeding will discard all changes. There is no undo. Are you sure?";
      evt.returnValue = unsaved_changes_warning;
      return unsaved_changes_warning;
    }
  }
}

export default ViewGameTypes;
